import React from 'react';
import { Card, Flex, Typography, theme } from 'antd';
import { CloseCircleFilled } from '@ant-design/icons';

import CloudflareHelpActions from './CloudflareHelpActions';

const { Text } = Typography;

export type CloudflareFailureCardProps = React.PropsWithChildren<{
  title: string;
  askNexusLabel: string;
  guidesLabel: string;
  onAskNexus: () => void;
}>;

/** The failure frame of the setup screen (Figma 4762-8322). */
const CloudflareFailureCard = ({
  title,
  askNexusLabel,
  guidesLabel,
  onAskNexus,
  children,
}: CloudflareFailureCardProps) => {
  const { token } = theme.useToken();

  return (
    <Card
      role="alert"
      style={{ borderColor: token.colorError }}
      styles={{ body: { padding: token.paddingLG } }}
    >
      <Flex gap={token.marginSM} align="flex-start">
        <CloseCircleFilled
          style={{ color: token.colorError, fontSize: token.fontSizeHeading3 }}
        />
        <Flex vertical gap={token.marginXS} flex={1}>
          <Text strong style={{ fontSize: token.fontSizeLG }}>
            {title}
          </Text>

          {children}

          <CloudflareHelpActions
            askNexusLabel={askNexusLabel}
            guidesLabel={guidesLabel}
            onAskNexus={onAskNexus}
          />
        </Flex>
      </Flex>
    </Card>
  );
};

export default CloudflareFailureCard;
